var _path, _rect, _line, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 6.68629 6.68629 4 10 4H30C33.3137 4 36 6.68629 36 10V14H4V10Z",
    fill: "#E5E5EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    rx: 6,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 14,
    x2: 35,
    y2: 14,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0019 19.38C18.2169 19.38 16.9869 20.685 16.9869 22.245C16.9869 23.1 17.3319 23.85 17.9619 24.345C17.1069 24.825 16.5819 25.68 16.5819 26.865C16.5819 28.905 18.1719 30.12 20.0019 30.12C21.8319 30.12 23.4219 28.905 23.4219 26.865C23.4219 25.68 22.8819 24.825 22.0269 24.345C22.6569 23.85 23.0169 23.1 23.0169 22.245C23.0169 20.685 21.7869 19.38 20.0019 19.38ZM20.0019 25.35C20.8569 25.35 21.5319 25.89 21.5319 26.865C21.5319 27.84 20.8569 28.38 20.0019 28.38C19.1469 28.38 18.4719 27.84 18.4719 26.865C18.4719 25.89 19.1469 25.35 20.0019 25.35ZM20.0019 20.97C20.7669 20.97 21.2619 21.495 21.2619 22.275C21.2619 23.07 20.7669 23.61 20.0019 23.61C19.2369 23.61 18.7419 23.07 18.7419 22.275C18.7419 21.495 19.2369 20.97 20.0019 20.97Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar8);
export default __webpack_public_path__ + "static/media/calendar-8.9d142f6477e2aafe4ddf45ce228c04e9.svg";
export { ForwardRef as ReactComponent };